export default __webpack_public_path__ + "static/media/img-signin.cba9a972.jpg";